import * as S from "./styled";
import { useForm, SubmitHandler, Controller } from "react-hook-form";
import axiosInstance from "services/axiosInstance";
import { NumericFormat } from "react-number-format";
/**
 * Components
 */
import LayoutWithList from "../../../LayoutModal/WithList";
import ActionButton from "../../../Button/ActionButton";
import Loading from "../../../../components/Loading";
/**
 * hooks
 */
import apiRequest from "../../../../hooks/apiRequest";
import { useEffect } from "react";
import useLoading from "../../../../hooks/useLoading";

type Inputs = {
  brand: string;
  discount: string;
};

interface ICreate {
  selectedUrlId: number | null;
  isOpenModalBraind: boolean;
  setModalClose: () => void;
  updateList: () => void;
}

export default function Update({
  isOpenModalBraind,
  setModalClose,
  updateList,
  selectedUrlId,
}: ICreate) {
  const {
    register,
    handleSubmit: handleFormSubmit,
    control,
    setValue,
    formState: { errors },
  } = useForm<Inputs>();

  const { isLoading, startLoading, stopLoading } = useLoading();

  const fetchData = async () => {
    startLoading();
    try {

      const response = await axiosInstance.get(`brand/${selectedUrlId}`);

      const addressData = response.data;
      for (const key in addressData) {
        setValue(key as keyof Inputs, addressData[key]);
      }

    } catch (error) {
      console.log("Error: ", error);
    } finally {
      stopLoading();
    }
  };

  useEffect(() => {
    if (isOpenModalBraind && selectedUrlId !== null) {
      fetchData();
    }
  }, [isOpenModalBraind, selectedUrlId]);

  const onSubmit: SubmitHandler<Inputs> = async (data) => {
    startLoading();
    try {
      const formattedData = {
        ...data,
        brand: data.brand.toUpperCase(), // Aqui você força caixa alta
      };

      const response = await apiRequest(`brand/${selectedUrlId}`, "PUT", formattedData);
      if (response.status === 200) {
        alert("Grife atualizada com sucesso!");
        updateList();
        setModalClose();
      }
    } catch (error: any) {
      alert(error.message || "Ocorreu um erro ao criar o fornecedor.");
    } finally {
      stopLoading();
    }
  };

  if (isOpenModalBraind) {
    return (
      <LayoutWithList
        title="Atualizar Grife"
        subTitle="Atualize as informações da grife em sua base de dados."
        setModalClose={setModalClose}
      >
        {isLoading ? (
          <Loading />
        ) : (
          <S.Container>
            <S.SeparateDiv>
              <S.FormInput>
                <S.Label>
                  Grife
                  <span>*</span>
                </S.Label>
                <S.Input
                  placeholder="Informe a grife"
                  type="text"
                  {...register("brand", { required: true })}
                />
                {errors.brand && <S.InforErro>Campo Obrigatório</S.InforErro>}
              </S.FormInput>

              <S.ContentButton>
                <ActionButton
                  name="Atualizar"
                  onClick={handleFormSubmit(onSubmit)}
                />
              </S.ContentButton>
            </S.SeparateDiv>
          </S.Container>
        )}
      </LayoutWithList>
    );
  }
  return null;
}
